import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-missed-info',
  templateUrl: './missed-info.component.html',
  styleUrls: ['./missed-info.component.scss']
})
export class MissedInfoComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
